/**
 * Après une tentative de réservation, amène le message de retour (confirmation
 * ou erreur) en haut de la zone visible et y place le focus.
 *
 * Pas d'ancre (#…) : le widget vit dans la page du tenant, une ancre
 * modifierait son URL et son historique. On défile vers l'élément lui-même ;
 * `scroll-margin-top` laisse la place à un éventuel en-tête fixe de la page
 * hôte (réglable par l'intégrateur via `--rdv-scroll-offset`).
 */

export const feedbackStyles = `
.rdv-root .rdv-status,
.rdv-root .rdv-confirmation {
  scroll-margin-top: var(--rdv-scroll-offset, 16px);
}

.rdv-root .rdv-status:focus,
.rdv-root .rdv-confirmation:focus {
  outline: none;
}
`;

/**
 * @param {ParentNode} root  racine de rendu (shadow root ou élément)
 * @param {{status: string}} state
 * @param {Window} [win]  injectable pour les tests
 * @returns {Element|null} l'élément révélé, ou null
 */
export function revealFeedback(root, state, win = globalThis.window) {
  const selector = state.status === "success" ? ".rdv-confirmation" : ".rdv-status";
  const target = root?.querySelector?.(selector);
  if (!target) {
    return null;
  }

  const reduceMotion = Boolean(win?.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches);
  if (typeof target.scrollIntoView === "function") {
    target.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "start" });
  }

  // Focus programmatique (élément non interactif) : annoncé par les lecteurs
  // d'écran, sans re-déclencher de défilement.
  if (!target.hasAttribute?.("tabindex")) {
    target.setAttribute?.("tabindex", "-1");
  }
  target.focus?.({ preventScroll: true });
  return target;
}
